// import Dashboard from "views/Dashboard/Dashboard";
// import Company from "views/Company/Company";
// import Loyality from "views/Loyality/Loyality";
import UserProfile from "views/UserProfile/UserProfile";
import StubPage from "views/Stub/StubPage";
import Feedback from "views/Feedback/Feedback";
import Company from "../views/Company/Company";
import Pushes from "../views/Pushes/Pushes";
import Grafic from "../views/Grafic/Grafic";
// import TableList from "views/TableList/TableList";
// import Typography from "views/Typography/Typography";
// import Icons from "views/Icons/Icons";
// import Maps from "views/Maps/Maps";
// import Notifications from "views/Notifications/Notifications";
// import Upgrade from "views/Upgrade/Upgrade";

const dashboardRoutes = [
  {
    path: "/user",
    name: "Настройки",
    icon: "pe-7s-config",
    component: UserProfile
  },
  // {
  //   path: "/company",
  //   name: "Компания",
  //   icon: "pe-7s-rocket",
  //   component: Company
  // },
  // {
  //   path: "/loyality",
  //   name: "Лояльность",
  //   icon: "pe-7s-diamond",
  //   component: Dashboard
  // },
  {
    path: "/clients",
    name: "Клиенты",
    icon: "pe-7s-graph",
    component: Company
  },
  {
    path: "/notification",
    name: "Оповещения",
    icon: "pe-7s-volume1",
    component: Pushes
  },
    // {
    //     path: "/grafic",
    //     name: "Отчетность",
    //     icon: "pe-7s-speaker",
    //     component: Grafic,
    // },
  // {
  //   path: "/table",
  //   name: "Table List",
  //   icon: "pe-7s-note2",
  //   component: TableList
  // },
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   icon: "pe-7s-news-paper",
  //   component: Typography
  // },
  // { path: "/icons", name: "Icons", icon: "pe-7s-science", component: Icons },
  // { path: "/maps", name: "Maps", icon: "pe-7s-map-marker", component: Maps },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   icon: "pe-7s-bell",
  //   component: Notifications
  // },
  {
    upgrade: true,
    path: "/feedback",
    name: "Обратная связь",
    icon: "pe-7s-speaker",
    component: Feedback
  },
  { redirect: true, path: "/", to: "/user", name: "Настройки" }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx